import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredData: "exid" | "timestamp" | "both";
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredData,
}) => {
  const { exid, timestamp } = useAppContext();

  const hasRequiredData = () => {
    switch (requiredData) {
      case "exid":
        return !!exid;
      case "timestamp":
        return !!timestamp;
      case "both":
        return !!exid && !!timestamp;
      default:
        return false;
    }
  };

  if (!hasRequiredData()) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
